interface IAssignees {
  code: string
  description: string
  id: number
  isActive: boolean
}

interface IMockedResources {
  assigneeIds: number[]
  assignees: IAssignees[]
  code: string
  description: string
  id: number
  isActive: boolean
  supervisorId: number
}

export const mockedResources: IMockedResources[] = [
  {
    supervisorId: 343,
    assignees: [],
    assigneeIds: [70, 71, 72, 73, 74, 75, 76, 78, 1000190],
    code: 'BI.LMA',
    description: 'XOM Machinist',
    isActive: true,
    id: 569,
  },
  {
    supervisorId: 345,
    assignees: [],
    assigneeIds: [62, 63, 64, 65, 66, 67, 68, 69, 1000190, 1000239, 1000242],
    code: 'BI.LCIN',
    description: 'Contractor Insulator',
    isActive: true,
    id: 570,
  },
  {
    supervisorId: 363,
    assignees: [],
    assigneeIds: [92, 93, 94, 95, 96, 97, 1000066, 1000067, 1000190],
    code: 'BI.LIT',
    description: 'XOM Instrument',
    isActive: true,
    id: 571,
  },
  {
    supervisorId: 345,
    assignees: [],
    assigneeIds: [49, 50, 51, 52, 1000190],
    code: 'BI.LCCAS',
    description: 'Carpenter Scaffold',
    isActive: true,
    id: 572,
  },
  {
    supervisorId: 347,
    assignees: [],
    assigneeIds: [
      440, 444, 446, 450, 452, 453, 457, 458, 459, 461, 1000190, 1000241,
    ],
    code: 'BI.LCEL',
    description: 'Contractor Electrical Journeyman',
    isActive: true,
    id: 573,
  },
  {
    supervisorId: 348,
    assignees: [],
    assigneeIds: [91, 330, 711, 712, 713, 1000190],
    code: 'BI.LEL',
    description: 'XOM Electrician',
    isActive: true,
    id: 574,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000177, 1000190],
    code: 'BI.TDL',
    description: 'LAG TIME',
    isActive: true,
    id: 575,
  },
  {
    supervisorId: 364,
    assignees: [],
    assigneeIds: [98, 99, 100, 102, 103, 104, 105, 175, 1000189, 1000190],
    code: 'BI.LAN',
    description: 'XOM Analyzer',
    isActive: true,
    id: 576,
  },
  {
    supervisorId: 345,
    assignees: [],
    assigneeIds: [53, 54, 55, 56, 57, 126, 1000190],
    code: 'BI.LCLA',
    description: 'Laborer General',
    isActive: true,
    id: 577,
  },
  {
    supervisorId: 350,
    assignees: [],
    assigneeIds: [117, 118, 119, 120, 121, 122, 123, 124, 125, 1000190],
    code: 'BI.LCPF',
    description: 'Contractor Pipefitter',
    isActive: true,
    id: 578,
  },
  {
    supervisorId: 351,
    assignees: [],
    assigneeIds: [1000190, 1000237, 1000238],
    code: 'BI.LCIVIL',
    description: 'COP Construction',
    isActive: true,
    id: 579,
  },
  {
    supervisorId: 350,
    assignees: [],
    assigneeIds: [115, 116, 1000190, 1000236],
    code: 'BI.LCBM',
    description: 'Contractor Boilermaker',
    isActive: true,
    id: 580,
  },
  {
    supervisorId: 345,
    assignees: [],
    assigneeIds: [60, 61, 1000190],
    code: 'BI.LCLAA',
    description: 'Laborer Asbestos',
    isActive: true,
    id: 581,
  },
  {
    supervisorId: 352,
    assignees: [],
    assigneeIds: [139, 143, 148, 150, 151, 216, 707, 1000190],
    code: 'BI.LCVT',
    description: 'Vacuum Truck Contractor',
    isActive: true,
    id: 582,
  },
  {
    supervisorId: 353,
    assignees: [],
    assigneeIds: [83, 84, 127, 837, 1000190],
    code: 'BI.LRI',
    description: 'XOM Transportation Dept.',
    isActive: true,
    id: 583,
  },
  {
    supervisorId: 345,
    assignees: [],
    assigneeIds: [58, 59, 1000190],
    code: 'BI.LCPA',
    description: 'Contractor Painting/Blasting',
    isActive: true,
    id: 584,
  },
  {
    supervisorId: 350,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.LCOP',
    description: 'Contractor Operator',
    isActive: true,
    id: 585,
  },
  {
    supervisorId: 353,
    assignees: [],
    assigneeIds: [86, 836, 1000190],
    code: 'BI.LPT',
    description: 'XOM Plant Trades',
    isActive: true,
    id: 586,
  },
  {
    supervisorId: 342,
    assignees: [],
    assigneeIds: [79, 80, 81, 147, 183, 184, 185, 1000190],
    code: 'BI.LPF',
    description: 'XOM Pipefitter',
    isActive: true,
    id: 587,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000176, 1000177, 1000190],
    code: 'BI.LPL',
    description: 'Mechanical Planners',
    isActive: true,
    id: 588,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000176, 1000190],
    code: 'BI.LIS',
    description: 'XOM Inspector',
    isActive: true,
    id: 589,
  },
  {
    supervisorId: 355,
    assignees: [],
    assigneeIds: [105, 107, 108, 109, 110, 111, 128, 1000189, 1000190],
    code: 'BI.LCIS',
    description: 'Contractor Inspection Services',
    isActive: true,
    id: 590,
  },
  {
    supervisorId: 356,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.LCLR',
    description: 'Plant Services Inc.',
    isActive: true,
    id: 591,
  },
  {
    supervisorId: 344,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.LCONCSC',
    description: 'Continuing Service Contractor',
    isActive: true,
    id: 592,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.P2CO',
    description: 'F2C PROCESS OPERATOR',
    isActive: true,
    id: 593,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.P2BO',
    description: 'F2B PROCESS OPERATOR',
    isActive: true,
    id: 594,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.P2AO',
    description: 'F2A PROCESS OPERATOR',
    isActive: true,
    id: 595,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000176, 1000177, 1000178, 1000190, 1000240],
    code: 'BI.P1AO',
    description: 'F1A PROCESS OPERATOR',
    isActive: true,
    id: 596,
  },
  {
    supervisorId: 352,
    assignees: [],
    assigneeIds: [140, 142, 1000190],
    code: 'BI.LCHJ',
    description: 'Hyjet Contractor',
    isActive: true,
    id: 597,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.P1BO',
    description: 'F1B PROCESS OPERATOR',
    isActive: true,
    id: 598,
  },
  {
    supervisorId: 364,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.LAN.L',
    description: 'XOM Analyzer Lab',
    isActive: true,
    id: 623,
  },
  {
    supervisorId: 345,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.LCLAS',
    description: 'Resource automatically created by ISTe interface',
    isActive: true,
    id: 1335,
  },
  {
    supervisorId: 349,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.TDLJC',
    description: 'Time Delay before Job Closure',
    isActive: true,
    id: 1906,
  },
  {
    supervisorId: 343,
    assignees: [],
    assigneeIds: [1000190, 1000240],
    code: 'BI.LCMA',
    description: 'Contractor Machinist',
    isActive: true,
    id: 2024,
  },
  {
    supervisorId: 344,
    assignees: [],
    assigneeIds: [1000190],
    code: 'BI.LCGAGNON',
    description: 'Gagnon',
    isActive: true,
    id: 2185,
  },
]
